// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import "./App.css";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Register from "./Components/Register/Register";
// import Login from "./Components/Login/Login";
// import Dashboard from "./Components/Dashboard/Dashboard";
// import Layout from "./Components/Side-Navbar/Layout";
// import Lead from "./Components/Lead Page/Lead";
// import CreateAccount from "./Components/Account/Create-Account";
// import ViewAccount from "./Components/Account/ViewAccount";
// import ProfilePage from "./Components/Profile/Profile";
// import ResetPassword from "./Components/Login/ResetPassword";
// import NotFoundPage from "./Components/NotFoundPage/NotFoundPage";
// import Issues from "./Components/Issues/Issues";
// import ContactForm from "./Components/SendSingle/SendSingle";
// import ContactForm2 from "./Components/userprofile/userprofile";
// import ContactForm3 from "./Components/Send Bulk/sendbulk";
// import axios from "axios";
// import { getAccessToken } from "./token";
// import { SmsReports } from "./Components/SmsReports/SmsReports";
// import WebsiteLayout from "./Components/WebsiteLayout/WebsiteLayout";
// import Home from "./Components/WebsiteData/Home";
// import About from "./Components/WebsiteData/About/About";
// import DLTConfiguration from "./Components/Configuration/Configuration";
// import { Senders } from "./Components/Senders/Senders";
// import { Templates } from "./Components/Templates/Templates";
// import Balance from './Components/Account/Balance';
// import { Suspendedcampaign } from "./Components/Campaign/Suspendedcampaign";
// import { Controlpanel } from "./Components/Account/Controlpanel";
// import { Pricing } from "./Components/WebsiteData/Pricing/Pricing";



// function App() {
//   axios.defaults.headers.common["Authorization"] = `Bearer ${getAccessToken()}`;

//   return (
//     <div className="App dark:bg-gray-900 dark:text-white">
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//         style={{ zIndex: 9999 }}
//       />

//       <Routes>

//         {/* all  static website   routes here  start */}

//         {/* Public pages with header & footer */}
//         <Route
//           path="/"
//           element={
//             <WebsiteLayout>
//               <Home />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/about"
//           element={
//             <WebsiteLayout>
//               <About />
//             </WebsiteLayout>
//           }
//         />

//         {/* <Route
//   path="/contact"
//   element={
//     <WebsiteLayout>
//       <Contact />
//     </WebsiteLayout>
//   }
// /> */}


//         {/* all  dashboard  routes here  start */}
//         {/* Pages without Sidebar */}
//         <Route path="/register" element={<Register />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/reset-password" element={<ResetPassword />} />

//         {/* Pages with Sidebar */}
//         <Route
//           path="/dashboard"
//           element={
//             <Layout>
//               <Dashboard />
//             </Layout>
//           }
//         />
//         <Route
//           path="/userprofile"
//           element={
//             <Layout>
//               <ContactForm2 />
//             </Layout>
//           }
//         />
//         <Route
//           path="/sendsingle"
//           element={
//             <Layout>
//               <ContactForm />
//             </Layout>
//           }
//         />


//         <Route
//           path="/sendbulk"
//           element={
//             <Layout>
//               <ContactForm3 />
//             </Layout>
//           }
//         />

//         <Route
//           path="/issues"
//           element={
//             <Layout>
//               <Issues />
//             </Layout>
//           }
//         />

//         <Route
//           path="/createAccount"
//           element={
//             <Layout>
//               <CreateAccount />
//             </Layout>
//           }
//         />
//         <Route
//           path="/viewAccount"
//           element={
//             <Layout>
//               <ViewAccount />
//             </Layout>
//           }
//         />

//         <Route
//           path="/profile"
//           element={
//             <Layout>
//               <ProfilePage />
//             </Layout>
//           }
//         />
//         <Route
//           path="/reports"
//           element={
//             <Layout>
//               <SmsReports />
//             </Layout>
//           }
//         />

//         {/* <Route
//           path="/dlt-configuration"
//           element={
//             <Layout>
//               <DLTConfiguration/>
//             </Layout>
//           }
//         /> */}


//          <Route
//           path="/senders"
//           element={
//             <Layout>
//               <Senders />
//             </Layout>
//           }
//         />
//          <Route
//           path="/templates"
//           element={
//             <Layout>
//               <Templates />
//             </Layout>
//           }
//         />
//          <Route
//           path="/balance"
//           element={
//             <Layout>
//               <Balance />
//             </Layout>
//           }
//         />
//           <Route
//           path="/suspended-campaign"
//           element={
//             <Layout>
//               <Suspendedcampaign />
//             </Layout>
//           }
//         />

//             <Route
//           path="/control-panel"
//           element={
//             <Layout>
//               <Controlpanel />
//             </Layout>
//           }
//         />


//             <Route
//           path="/pricing"
//           element={
//                <WebsiteLayout>
//               <Pricing />
//             </WebsiteLayout>
//          }
//         />

//         {/* all  dashboard  routes here  end */}
//         <Route path="*" element={<NotFoundPage />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;



// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import "./App.css";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Register from "./Components/Register/Register";
// import Login from "./Components/Login/Login";
// import Dashboard from "./Components/Dashboard/Dashboard";
// import Layout from "./Components/Side-Navbar/Layout";

// import Lead from "./Components/Lead Page/Lead";
// import CreateAccount from "./Components/Account/Create-Account";
// import ViewAccount from "./Components/Account/ViewAccount";
// import ProfilePage from "./Components/Profile/Profile";
// import ResetPassword from "./Components/Login/ResetPassword";
// import NotFoundPage from "./Components/NotFoundPage/NotFoundPage";
// import Issues from "./Components/Issues/Issues";
// import ContactForm from "./Components/SendSingle/SendSingle";
// import ContactForm2 from "./Components/userprofile/userprofile";
// import ContactForm3 from "./Components/Send Bulk/sendbulk";
// import axios from "axios";
// import { getAccessToken } from "./token";
// import { SmsReports } from "./Components/SmsReports/SmsReports";
// import WebsiteLayout from "./Components/WebsiteLayout/WebsiteLayout";
// import Home from "./Components/WebsiteData/Home";
// import About from "./Components/WebsiteData/About/About";
// import DLTConfiguration from "./Components/Configuration/Configuration";
// import { Senders } from "./Components/Senders/Senders";
// import { Templates } from "./Components/Templates/Templates";
// import Balance from './Components/Account/Balance';
// import { Suspendedcampaign } from "./Components/Campaign/Suspendedcampaign";
// import { Controlpanel } from "./Components/Account/Controlpanel";
// import { Pricing } from "./Components/WebsiteData/Pricing/Pricing";
// import PrivateRoute from "./Components/routes/PrivateRoute";
// import Contactus  from "./Components/WebsiteData/Contactus/Contactus";
// import { Privacypolicy } from "./Components/WebsiteData/Privacypolicy";
// import { Termsandconditions } from "./Components/WebsiteData/Termsandconditions";
// import Features from "./Components/WebsiteData/Features";
// import { Supportfaq } from "./Components/Supportfaq/Supportfaq";
// import { Toaster } from "react-hot-toast";
// import { Queries } from "./Components/Account/Queries";

// function App() {
//   // Set authorization header for all axios requests
//   const token = getAccessToken();
//   if (token) {
//     axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   }

//   return (
//     <div className="App dark:bg-gray-900 dark:text-white">
//       <Toaster position="top-center" />
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//         style={{ zIndex: 9999 }}
//       />

//       <Routes>
//         {/* Public routes (no authentication required) */}
//         <Route
//           path="/"
//           element={
//             <WebsiteLayout>
//               <Home />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/about"
//           element={
//             <WebsiteLayout>
//               <About />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/pricing"
//           element={
//             <WebsiteLayout>
//               <Pricing />
//             </WebsiteLayout>
//           }
//         />


//         <Route
//           path="/contact"
//           element={
//             <WebsiteLayout>
//               <Contactus />
//             </WebsiteLayout>
//           }
//         />
//         <Route
//           path="/privacy-policy"
//           element={
//             <WebsiteLayout>
//               <Privacypolicy />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/terms-and-conditions"
//           element={
//             <WebsiteLayout>
//               <Termsandconditions />
//             </WebsiteLayout>
//           }
//         />
//          <Route
//           path="/features"
//           element={
//             <WebsiteLayout>
//               <Features />
//             </WebsiteLayout>
//           }
//         />


//         {/* Authentication routes */}
//         <Route path="/register" element={<Register />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/reset-password" element={<ResetPassword />} />

//         {/* Protected routes (require authentication) */}
//         <Route
//           path="/dashboard"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Dashboard />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/userprofile"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContactForm2 />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/sendsingle"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContactForm />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/sendbulk"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContactForm3 />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/issues"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Issues />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/createAccount"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <CreateAccount />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/viewAccount"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ViewAccount />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/profile"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProfilePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/reports"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <SmsReports />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/senders"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Senders />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/templates"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Templates />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/balance"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Balance />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/suspended-campaign"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Suspendedcampaign />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/control-panel"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Controlpanel />
//               </Layout>
//             </PrivateRoute>
//           }
//         />


//             <Route
//           path="/queries"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Queries/>
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//           <Route
//           path="/settings"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProfilePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />


//           <Route
//           path="/support-faq"
//           element={
//             <PrivateRoute>
//               {/* <Layout> */}
//                 <Supportfaq />
//               {/* </Layout> */}
//             </PrivateRoute>
//           }
//         />
//         {/* 404 Route */}
//         <Route path="*" element={<NotFoundPage />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;






// import React, { useEffect, useState } from "react";
// import { Routes, Route,useLocation  } from "react-router-dom";
// import "./App.css";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Register from "./Components/Register/Register";
// import Login from "./Components/Login/Login";
// import Dashboard from "./Components/Dashboard/Dashboard";
// import Layout from "./Components/Side-Navbar/Layout";
// import Lead from "./Components/Lead Page/Lead";
// import CreateAccount from "./Components/Account/Create-Account";
// import ViewAccount from "./Components/Account/ViewAccount";
// import ProfilePage from "./Components/Profile/Profile";
// import ResetPassword from "./Components/Login/ResetPassword";
// import NotFoundPage from "./Components/NotFoundPage/NotFoundPage";
// import Issues from "./Components/Issues/Issues";
// import ContactForm from "./Components/SendSingle/SendSingle";
// import ContactForm2 from "./Components/userprofile/userprofile";
// import ContactForm3 from "./Components/Send Bulk/sendbulk";
// import axios from "axios";
// import { getAccessToken } from "./token";
// import SmsReports from './Components/SmsReports/SmsReports';
// import WebsiteLayout from "./Components/WebsiteLayout/WebsiteLayout";
// import Home from "./Components/WebsiteData/Home";
// import About from "./Components/WebsiteData/About/About";
// import DLTConfiguration from "./Components/Configuration/Configuration";
// import { Senders } from "./Components/Senders/Senders";
// import { Templates } from "./Components/Templates/Templates";
// import Balance from './Components/Account/Balance';
// import { Suspendedcampaign } from "./Components/Campaign/Suspendedcampaign";
// import { Controlpanel } from "./Components/Account/Controlpanel";
// import { Pricing } from "./Components/WebsiteData/Pricing/Pricing";
// import PrivateRoute from "./Components/routes/PrivateRoute";
// import Contactus from "./Components/WebsiteData/Contactus/Contactus";
// import { Privacypolicy } from "./Components/WebsiteData/Privacypolicy";
// import { Termsandconditions } from "./Components/WebsiteData/Termsandconditions";
// import Features from "./Components/WebsiteData/Features";
// import { Supportfaq } from "./Components/Supportfaq/Supportfaq";
// import { Toaster } from "react-hot-toast";
// import { Queries } from "./Components/Account/Queries";
// import { Blogs } from "./Components/WebsiteData/Blogs"
// import { Faqs } from "./Components/WebsiteData/Faqs";
// import { Dlt } from "./Components/WebsiteData/Dlt";
// import { Careers } from "./Components/WebsiteData/Careers";
// import { Bulksms } from "./Components/WebsiteData/Products/Bulksms";
// import { Ivr } from "./Components/WebsiteData/Products/Ivr";
// import { Lms } from "./Components/WebsiteData/Products/Lms";
// import Otp from "./Components/WebsiteData/Products/Otp";
// import Missedcall from "./Components/WebsiteData/Products/Missedcall";
// import Vphone from "./Components/WebsiteData/Products/Vphone";
// import Whatsapp from "./Components/WebsiteData/Products/Whatsapp";
// import Employee from "./Components/WebsiteData/Products/Employee";
// import SplashScreen from "./Components/Splashscreen/Splash";
// import Contacts from "./Components/Contacts/Contacts";


// function App() {
//   const [showSplash, setShowSplash] = useState(true);

//   // REMOVE the old useEffect with the 1000ms timer
//   // We will now wait for the SplashScreen to tell us it's done

//   // Set authorization header for all axios requests
//   const token = getAccessToken();
//   if (token) {
//     axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   }
//   const location = useLocation();

//   const isHomePage = location.pathname === "/";
//   return (
//     <>
//       {/* UPDATE THIS LINE: Pass the onComplete prop */}
//       {/* {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />} */}
//       {isHomePage && showSplash && (
//   <SplashScreen onComplete={() => setShowSplash(false)} />
// )}


//       <div className="App dark:bg-gray-900 dark:text-white">

//       <Toaster position="top-center" />
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//         style={{ zIndex: 9999 }}
//       />

//       <Routes>
//         {/* Public routes (no authentication required) */}
//         <Route
//           path="/"
//           element={
//             <WebsiteLayout>
//               <Home />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/about"
//           element={
//             <WebsiteLayout>
//               <About />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/pricing"
//           element={
//             <WebsiteLayout>
//               <Pricing />
//             </WebsiteLayout>
//           }
//         />


//         <Route
//           path="/contact"
//           element={
//             <WebsiteLayout>
//               <Contactus />
//             </WebsiteLayout>
//           }
//         />
//         <Route
//           path="/privacy-policy"
//           element={
//             <WebsiteLayout>
//               <Privacypolicy />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/terms-and-conditions"
//           element={
//             <WebsiteLayout>
//               <Termsandconditions />
//             </WebsiteLayout>
//           }
//         />
//         <Route
//           path="/features"
//           element={
//             <WebsiteLayout>
//               <Features />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/resources/blog"
//           element={
//             <WebsiteLayout>
//               <Blogs />
//             </WebsiteLayout>
//           }
//         />
//         <Route
//           path="/resources/faq"
//           element={
//             <WebsiteLayout>
//               <Faqs />
//             </WebsiteLayout>
//           }
//         />


//         <Route
//           path="/resources/dlt-registration"
//           element={
//             <WebsiteLayout>
//               <Dlt />
//             </WebsiteLayout>
//           }
//         />


//         <Route
//           path="/company/careers"
//           element={
//             <WebsiteLayout>
//               <Careers />
//             </WebsiteLayout>
//           }
//         />


//         <Route
//           path="/products/bulk-sms"
//           element={
//             <WebsiteLayout>
//               <Bulksms />
//             </WebsiteLayout>
//           }
//         />


//         <Route
//           path="/products/ivr"
//           element={
//             <WebsiteLayout>
//               <Ivr />
//             </WebsiteLayout>
//           }
//         />


//         <Route
//           path="/products/lms"
//           element={
//             <WebsiteLayout>
//               <Lms />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/products/otp"
//           element={
//             <WebsiteLayout>
//               <Otp />
//             </WebsiteLayout>
//           }
//         />


//         <Route
//           path="/products/missed-call"
//           element={
//             <WebsiteLayout>
//               <Missedcall />
//             </WebsiteLayout>
//           }
//         />

//         <Route
//           path="/products/virtual-number"
//           element={
//             <WebsiteLayout>
//               <Vphone />
//             </WebsiteLayout>
//           }
//         />



//         <Route
//           path="/products/whatsapp"
//           element={
//             <WebsiteLayout>
//               <Whatsapp />
//             </WebsiteLayout>
//           }
//         />

//               <Route
//           path="/products/employee-tracking-system"
//           element={
//             <WebsiteLayout>
//               <Employee />
//             </WebsiteLayout>
//           }
//         />

//         {/* Authentication routes */}
//         <Route path="/register" element={<Register />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/reset-password" element={<ResetPassword />} />

//         {/* Protected routes (require authentication) */}
//         <Route
//           path="/dashboard"
//           element={
//               <Layout>
//                 <Dashboard />
//               </Layout>
//           }
//         />

//           <Route
//           path="/contacts"
//           element={
//              <PrivateRoute>
//               <Layout>
//                 <Contacts />
//               </Layout>
//            </PrivateRoute>
//           }
//         />
//         <Route
//           path="/userprofile"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContactForm2 />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/sendsingle"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContactForm />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/sendbulk"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContactForm3 />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/issues"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Issues />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/createAccount"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <CreateAccount />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/viewAccount"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ViewAccount />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/profile"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProfilePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/reports"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <SmsReports />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/senders"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Senders />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/templates"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Templates />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/balance"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Balance />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/suspended-campaign"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Suspendedcampaign />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/control-panel"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Controlpanel />
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//            <Route
//           path="/queries"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Queries/>
//               </Layout>
//             </PrivateRoute>
//           }
//         />

//         <Route
//           path="/settings"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProfilePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />


//         <Route
//           path="/support-faq"
//           element={
//             <PrivateRoute>
//               {/* <Layout> */}
//               <Supportfaq />
//               {/* </Layout> */}
//             </PrivateRoute>
//           }
//         />
//         {/* 404 Route */}
//         <Route path="*" element={<NotFoundPage />} />
//       </Routes>
//       </div>
//     </>
//   );
// }


// export default App;






import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Register from "./Components/Register/Register";
import Login from "./Components/Login/Login";
import Dashboard from "./Components/Dashboard/Dashboard";
import Layout from "./Components/Side-Navbar/Layout";
import Lead from "./Components/Lead Page/Lead";
import CreateAccount from "./Components/Account/Create-Account";
import ViewAccount from "./Components/Account/ViewAccount";
import ProfilePage from "./Components/Profile/Profile";
import ResetPassword from "./Components/Login/ResetPassword";
import NotFoundPage from "./Components/NotFoundPage/NotFoundPage";
import Issues from "./Components/Issues/Issues";
import ContactForm from "./Components/SendSingle/SendSingle";
import ContactForm2 from "./Components/userprofile/userprofile";
import ContactForm3 from "./Components/Send Bulk/sendbulk";
import axios from "axios";
import { getAccessToken } from "./token";
import SmsReports from './Components/SmsReports/SmsReports';
import WebsiteLayout from "./Components/WebsiteLayout/WebsiteLayout";
import Home from "./Components/WebsiteData/Home";
import About from "./Components/WebsiteData/About/About";
import DLTConfiguration from "./Components/Configuration/Configuration";
import { Senders } from "./Components/Senders/Senders";
import { Templates } from "./Components/Templates/Templates";
import Balance from './Components/Account/Balance';
import { Controlpanel } from "./Components/Account/Controlpanel";
import { Pricing } from "./Components/WebsiteData/Pricing/Pricing";
import PrivateRoute from "./Components/routes/PrivateRoute";
import Contactus from "./Components/WebsiteData/Contactus/Contactus";
import { Privacypolicy } from "./Components/WebsiteData/Privacypolicy";
import { Termsandconditions } from "./Components/WebsiteData/Termsandconditions";
import Features from "./Components/WebsiteData/Features";
import { Supportfaq } from "./Components/Supportfaq/Supportfaq";
import { Toaster } from "react-hot-toast";
import { Queries } from "./Components/Account/Queries";
import { Blogs } from "./Components/WebsiteData/Blogs"
import { Faqs } from "./Components/WebsiteData/Faqs";
import { Dlt } from "./Components/WebsiteData/Dlt";
import { Careers } from "./Components/WebsiteData/Careers";
import { Bulksms } from "./Components/WebsiteData/Products/Bulksms";
import { Ivr } from "./Components/WebsiteData/Products/Ivr";
import { Lms } from "./Components/WebsiteData/Products/Lms";
import Otp from "./Components/WebsiteData/Products/Otp";
import Missedcall from "./Components/WebsiteData/Products/Missedcall";
import Vphone from "./Components/WebsiteData/Products/Vphone";
import Whatsapp from "./Components/WebsiteData/Products/Whatsapp";
import Employee from "./Components/WebsiteData/Products/Employee";
import SplashScreen from "./Components/Splashscreen/Splash";
import Education from "./Components/WebsiteData/Solutions/Education";
import Healthcare from "./Components/WebsiteData/Solutions/Healthcare";
import Realestate from "./Components/WebsiteData/Solutions/Realestate";
import Bfsi from "./Components/WebsiteData/Solutions/Bfsi";
import Travel from "./Components/WebsiteData/Solutions/Travel";
import Ecommerce from "./Components/WebsiteData/Solutions/Ecommerce";
import Contacts from "./Components/Contacts/Contacts";
import Generateleads from "./Components/Generateleads/Generateleads";
import ApiReference from "./Components/Apireference/ApiReference";
import UserGuide from "./Components/Userguide/Userguide";
import Dndfilter from "./Components/Dndfilter/Dndfilter";


function App() {
  const [showSplash, setShowSplash] = useState(true);

  // REMOVE the old useEffect with the 1000ms timer
  // We will now wait for the SplashScreen to tell us it's done

  // Set authorization header for all axios requests
  const token = getAccessToken();
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
  const location = useLocation();

  const isHomePage = location.pathname === "/";
  return (
    <>
      {/* UPDATE THIS LINE: Pass the onComplete prop */}
      {/* {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />} */}
      {isHomePage && showSplash && (
        <SplashScreen onComplete={() => setShowSplash(false)} />
      )}


      <div className="App dark:bg-gray-900 dark:text-white">

        <Toaster position="top-center" />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          style={{ zIndex: 9999 }}
        />

        <Routes>
          {/* Public routes (no authentication required) */}
          <Route
            path="/"
            element={
              <WebsiteLayout>
                <Home />
              </WebsiteLayout>
            }
          />

          <Route
            path="/about"
            element={
              <WebsiteLayout>
                <About />
              </WebsiteLayout>
            }
          />

          <Route
            path="/pricing"
            element={
              <WebsiteLayout>
                <Pricing />
              </WebsiteLayout>
            }
          />


          <Route
            path="/contact"
            element={
              <WebsiteLayout>
                <Contactus />
              </WebsiteLayout>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <WebsiteLayout>
                <Privacypolicy />
              </WebsiteLayout>
            }
          />

          <Route
            path="/terms-and-conditions"
            element={
              <WebsiteLayout>
                <Termsandconditions />
              </WebsiteLayout>
            }
          />
          <Route
            path="/features"
            element={
              <WebsiteLayout>
                <Features />
              </WebsiteLayout>
            }
          />

          <Route
            path="/resources/blog"
            element={
              <WebsiteLayout>
                <Blogs />
              </WebsiteLayout>
            }
          />
          <Route
            path="/resources/faq"
            element={
              <WebsiteLayout>
                <Faqs />
              </WebsiteLayout>
            }
          />


          <Route
            path="/resources/dlt-registration"
            element={
              <WebsiteLayout>
                <Dlt />
              </WebsiteLayout>
            }
          />


          <Route
            path="/company/careers"
            element={
              <WebsiteLayout>
                <Careers />
              </WebsiteLayout>
            }
          />


          <Route
            path="/products/bulk-sms"
            element={
              <WebsiteLayout>
                <Bulksms />
              </WebsiteLayout>
            }
          />


          <Route
            path="/products/ivr"
            element={
              <WebsiteLayout>
                <Ivr />
              </WebsiteLayout>
            }
          />


          <Route
            path="/products/lms"
            element={
              <WebsiteLayout>
                <Lms />
              </WebsiteLayout>
            }
          />

          <Route
            path="/products/otp"
            element={
              <WebsiteLayout>
                <Otp />
              </WebsiteLayout>
            }
          />


          <Route
            path="/products/missed-call"
            element={
              <WebsiteLayout>
                <Missedcall />
              </WebsiteLayout>
            }
          />

          <Route
            path="/products/virtual-number"
            element={
              <WebsiteLayout>
                <Vphone />
              </WebsiteLayout>
            }
          />



          <Route
            path="/products/whatsapp"
            element={
              <WebsiteLayout>
                <Whatsapp />
              </WebsiteLayout>
            }
          />

          <Route
            path="/products/employee-tracking-system"
            element={
              <WebsiteLayout>
                <Employee />
              </WebsiteLayout>
            }
          />


          <Route
            path="/solutions/education"
            element={
              <WebsiteLayout>
                <Education />
              </WebsiteLayout>
            }
          />



          <Route
            path="/solutions/healthcare"
            element={
              <WebsiteLayout>
                <Healthcare />
              </WebsiteLayout>
            }
          />

          <Route
            path="/solutions/real-estate"
            element={
              <WebsiteLayout>
                <Realestate />
              </WebsiteLayout>
            }
          />

          <Route
            path="/solutions/finance"
            element={
              <WebsiteLayout>
                <Bfsi />
              </WebsiteLayout>
            }
          />


          <Route
            path="/solutions/travel"
            element={
              <WebsiteLayout>
                <Travel />
              </WebsiteLayout>
            }
          />


          <Route
            path="/solutions/e-commerce"
            element={
              <WebsiteLayout>
                <Ecommerce />
              </WebsiteLayout>
            }
          />

          {/* Authentication routes */}
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected routes (require authentication) */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />


          <Route
            path="/contacts"
            element={
              <PrivateRoute>
                <Layout>
                  <Contacts />
                </Layout>
              </PrivateRoute>
            }
          />


          <Route
            path="/userprofile"
            element={
              <PrivateRoute>
                <Layout>
                  <ContactForm2 />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/sendsingle"
            element={
              <PrivateRoute>
                <Layout>
                  <ContactForm />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/sendbulk"
            element={
              <PrivateRoute>
                <Layout>
                  <ContactForm3 />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/issues"
            element={
              <PrivateRoute>
                <Layout>
                  <Issues />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/createAccount"
            element={
              <PrivateRoute>
                <Layout>
                  <CreateAccount />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/viewAccount"
            element={
              <PrivateRoute>
                <Layout>
                  <ViewAccount />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Layout>
                  <ProfilePage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Layout>
                  <SmsReports />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/senders"
            element={
              <PrivateRoute>
                <Layout>
                  <Senders />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/templates"
            element={
              <PrivateRoute>
                <Layout>
                  <Templates />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/balance"
            element={
              <PrivateRoute>
                <Layout>
                  <Balance />
                </Layout>
              </PrivateRoute>
            }
          />



          <Route
            path="/control-panel"
            element={
              <PrivateRoute>
                <Layout>
                  <Controlpanel />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/queries"
            element={
              <PrivateRoute>
                <Layout>
                  <Queries />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Layout>
                  <ProfilePage />
                </Layout>
              </PrivateRoute>
            }
          />

          
          <Route
            path="/dnd-filter"
            element={
              <PrivateRoute>
                <Layout>
                  <Dndfilter />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/generate-leads"
            element={
              <PrivateRoute>
                <Layout>
                  <Generateleads />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/api-reference"
            element={
              <PrivateRoute>
                <Layout>
                  <ApiReference />
                </Layout>
              </PrivateRoute>
            }
          />


          <Route
            path="//user-guide"
            element={
              <PrivateRoute>
                <Layout>
                  <UserGuide />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/support-faq"
            element={
              <PrivateRoute>
                {/* <Layout> */}
                <Supportfaq />
                {/* </Layout> */}
              </PrivateRoute>
            }
          />
          {/* 404 Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </>
  );
}


export default App;